import { Injectable } from '@angular/core';

import { Environment } from '@r1-compass-library/environments/environment';
import { AssetRestService } from './rest/asset-rest.service';
import { PlayConfigAudit, PlayConfigAuditResult } from '@r1-compass-library/models/play/play-audit.model';
import { PlayConfigAuditSearch } from '@r1-compass-library/models/search/play-config-audit-search.model';
import { catchError, finalize, Observable, of, retry } from 'rxjs';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpHeaderConstants } from '@r1-compass-library/constants';

@Injectable({
    providedIn: 'root',
})
export class PlayConfigAuditService extends AssetRestService<PlayConfigAudit, PlayConfigAuditSearch> {
    protected override BASE_URL = Environment.baseUrl + '/frontend/play-config-audits';
    protected override TARGET_OBJECT = 'play audit';

    processNamePrefix = 'PlayConfigAuditService';

    findLatest(search: PlayConfigAuditSearch, additionalHeaders: any = {}): Observable<PlayConfigAuditResult> {
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams(),
        };

        this.setSearchParams(search, httpOptions);

        const process = `${this.processNamePrefix}.search`;
        this.spinnerService.addProcess(process, `Searching ${this.TARGET_OBJECT}s...`);
        return this.http.get<PlayConfigAuditResult>(`${this.BASE_URL}`, httpOptions).pipe(
            retry(0),
            catchError(() => of<PlayConfigAuditResult>()),
            finalize(() => this.spinnerService.completeProcess(process))
        );
    }
}
